import React from "react";
import ReactDOM from "react-dom/client";
import "./tailwind.css"; // Tailwind CSS - основний стиль
import "./Components/global-sci-fi.css"; // Глобальні sci-fi стилі
import "./Components/index.css"; // Додаткові стилі компонентів
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { persistor, store } from "./Components/store";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./Components/Utils/queryClient";
import Ready2HuntMark from "./Assets/Logo/ready2hunt-mark.png";

document.title = "Ready2Hunt Admin";
const favicon = document.querySelector("link[rel='icon']") || document.createElement("link");
favicon.rel = "icon";
favicon.href = Ready2HuntMark;
document.head.appendChild(favicon);
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
